import {
  FaQuestionCircle,
  FaCode,
  FaCss3Alt,
  FaGlobe,
  FaVideo,
  FaCube,
  FaDatabase,
  FaDesktop,
  FaPaintBrush,
  FaCamera,
  FaMobileAlt,
  FaLanguage,
  FaReact,
  FaJsSquare,
  FaNodeJs,
  FaFilm,
  FaMagic,
  FaShapes,
  FaCut,
  FaPenSquare,
  FaPlay,
} from 'react-icons/fa';

// Reine Komponenten-Referenzen für flexibles Styling im JSX
const ICONS = {
  code: FaCode,
  css3: FaCss3Alt,
  globe: FaGlobe,
  video: FaVideo,
  "3d": FaCube,
  database: FaDatabase,
  desktop: FaDesktop,
  paintBrush: FaPaintBrush,
  camera: FaCamera,
  mobile: FaMobileAlt,
  language: FaLanguage,
  react: FaReact,
  javascript: FaJsSquare,
  nodejs: FaNodeJs,
  aftereffects: FaFilm,
  animation: FaMagic,
  compositing: FaCube,
  atechnik: FaShapes,
  schnitt: FaCut,
  compo: FaPenSquare,
  rendering: FaPlay,
  default: FaQuestionCircle,
};


// Farbzuordnung als Map gelöst 

export const ICON_COLORS = {
  code: "text-brand",
  css3: "text-brand",
  globe: "text-brand",
  video: "text-brand",
  "3d": "text-brand",
  database: "text-brand",
  desktop: "text-brand",
  paintBrush: "text-brand",
  camera: "text-brand",
  mobile: "text-brand",
  language: "text-brand",
  react: "text-brand",
  javascript: "text-brand",
  nodejs: "text-brand",
  aftereffects: "text-brand",
  animation: "text-brand",
  compositing: "text-brand",
  atechnik: "text-brand",
  schnitt: "text-brand",
  compo: "text-brand",
  rendering: "text-brand",
  default: "text-brand",
};


export default ICONS;
